import { gql } from '@apollo/client';

export default class AccountSettingsMutation {
static SAVE_DEFAULT_ACCOUNTING_SETTINGS = gql`
  mutation saveDefaultAccountingSettings($input: AccountingDefaultSettingsInput!) {
    saveDefaultAccountingSettings(input: $input)
  }
`;
}
